import React from 'react'
import PropTypes from "prop-types";

const PaymentSummary = (
    {
        itemTotal,
        deliveryChosen,
        deliveryCharge,
        totalToPayAsBritishCurrency,
        itemTitle,
    }
) => { 

    const formatter = Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
    });

    return (
        <div id="paymentTableWrapper">
            <table border="1" className="table">                
                <thead>
                    <tr>
                        <th scope="col">Item</th>
                        <th scope="col"></th>
                        <th scope="col">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            {itemTitle}
                        </td>
                        <td>
                        </td>
                        <td>
                            {formatter.format(itemTotal)}
                        </td>
                    </tr>
                </tbody>
                <tfoot>

                    <tr>
                        <td>
                        </td>
                        <th>
                            Item total
                        </th>
                        <td>
                            {formatter.format(itemTotal)}
                        </td>
                    </tr>

                    <tr>
                        <td>
                        </td>
                        <th>
                            Item delivery total
                        </th>
                        <td>
                            {deliveryChosen ? formatter.format(deliveryCharge) : "£0"}
                        </td>
                    </tr>

                    <tr>
                        <td>
                        </td>
                        <th>
                            Total to pay
                        </th>
                        <td>
                            {totalToPayAsBritishCurrency}
                        </td>
                    </tr>                  
                </tfoot>
            </table>
        </div>);
};

PaymentSummary.propTypes = {
    totalToPayAsBritishCurrency: PropTypes.string.isRequired,
    deliveryCharge: PropTypes.number.isRequired,
    deliveryChosen: PropTypes.bool.isRequired,
    itemTotal: PropTypes.number.isRequired,
    itemTitle: PropTypes.string.isRequired,
}

export default PaymentSummary;
